// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5abfc58b","845":"a544ef0b"}[chunkId] + ".chunk.js";
};